// components/VehiclesSection.js - Updated with drag-reorder support + your existing features
import React, { useState } from 'react';
import Section from './Section';
import './VehiclesSection.css'; // Import the dedicated CSS file

export default function VehiclesSection({ vehicles, setVehicles, isEditing, onImportRequest, complianceTier }) {
  const [urlInput, setUrlInput] = useState('');
  const [urlStatus, setUrlStatus] = useState({ message: '', type: '' });



  
  const moveItem = (list, from, to) => {
    const copy = [...list];
    const [moved] = copy.splice(from, 1);
    copy.splice(to, 0, moved);
    return copy;
  };

  const moveUp = (idx) => {
  if (idx <= 0) return;
  setVehicles((prev) => moveItem(prev, idx, idx - 1));
};

const moveDown = (idx) => {
  if (idx >= vehicles.length - 1) return;
  setVehicles((prev) => moveItem(prev, idx, idx + 1));
};


  const handleChange = (index, field, value) => {
    const newVehicles = [...vehicles];
    newVehicles[index][field] = value;

    // Reset lease/finance specific fields when type changes
    if (field === 'financeType') {
      if (value === 'lease') {
        newVehicles[index] = {
          ...newVehicles[index],
          apr: '',
          down: '',
          months: '',
          leaseMonths: 48,
          totalDueAtSigning: ''
        };
      } else {
        newVehicles[index] = {
          ...newVehicles[index],
          leaseMonths: '',
          totalDueAtSigning: '',
          apr: 5.9,
          months: 84,
          down: 20
        };
      }
    }

    setVehicles(newVehicles);
  };

  const handleMakeChange = (index, value) => {
    const newVehicles = [...vehicles];
    newVehicles[index].make = value;
    if (value !== 'Other') {
      newVehicles[index].customMake = '';
    }
    setVehicles(newVehicles);
  };

  const handleCustomMakeChange = (index, value) => {
    const newVehicles = [...vehicles];
    newVehicles[index].customMake = value;
    setVehicles(newVehicles);
  };

  const addVehicle = () => {
    setVehicles([
      ...vehicles,
      {
        year: '',
        make: '',
        model: '',
        salePrice: '',
        apr: 5.9,
        months: 84,
        down: 20,
        stockNumber: '',
        customMake: '',
        financeType: 'finance',
        leaseMonths: 48,
        totalDueAtSigning: ''
      }
    ]);
  };

  const removeVehicle = (index) => {
    setVehicles(vehicles.filter((_, i) => i !== index));
  };

  const calculateMonthlyPayment = (salePrice, downPct, apr, months) => {
    const downPayment = salePrice * (downPct / 100);
    const principal = salePrice - downPayment;
    const monthlyRate = apr / 100 / 12;
    const payment = (monthlyRate * principal) / (1 - Math.pow(1 + monthlyRate, -months));
    return isNaN(payment) ? 0 : Math.round(payment);
  };

  const parseVehicleURL = (url) => {
    try {
      setUrlStatus({ message: 'Parsing URL...', type: 'info' });
      url = url.trim().toLowerCase();

      let match = url.match(/(\d{4})-([a-zA-Z]+)-([a-zA-Z0-9-]+?)(?:-[a-f0-9]{32}|\.htm|$)/);
      if (match) {
        const year = match[1];
        const make = match[2].charAt(0).toUpperCase() + match[2].slice(1);
        const model = match[3]
          .split('-')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ');
        return { year, make, model };
      }

      match = url.match(/used-[^-]*-(\d{4})-([a-zA-Z]+)-([a-zA-Z0-9+\s-]+?)(?:-[a-zA-Z0-9]{17}|$)/);
      if (match) {
        const year = match[1];
        const make = match[2].charAt(0).toUpperCase() + match[2].slice(1);
        const model = match[3]
          .replace(/\+/g, ' ')
          .split(/[-\s]+/)
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ')
          .trim();
        return { year, make, model };
      }

      match = url.match(/inventory\/used-(\d{4})-([a-zA-Z]+)-([a-zA-Z0-9-]+?)(?:-[a-zA-Z0-9]{17}|\/|$)/);
      if (match) {
        const year = match[1];
        const make = match[2].charAt(0).toUpperCase() + match[2].slice(1);
        const model = match[3]
          .split('-')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ')
          .trim();
        return { year, make, model };
      }

      match = url.match(/\/used\/([a-zA-Z]+)\/(\d{4})\/([a-zA-Z0-9-]+?)(?:-[a-f0-9]{32}|\.htm|$)/);
      if (match) {
        const make = match[1].charAt(0).toUpperCase() + match[1].slice(1);
        const year = match[2];
        const model = match[3]
          .split('-')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ');
        return { year, make, model };
      }

      const yearMatch = url.match(/(\d{4})/);
      const makeMatch = url.match(
        /\/(ford|chevrolet|toyota|honda|nissan|hyundai|kia|mazda|subaru|volkswagen|bmw|mercedes|audi|lexus|acura|infiniti|cadillac|buick|gmc|jeep|ram|dodge|chrysler|tesla|volvo|mitsubishi)/i
      );

      if (yearMatch && makeMatch) {
        const year = yearMatch[1];
        const make = makeMatch[1].charAt(0).toUpperCase() + makeMatch[1].slice(1);
        return { year, make, model: '' };
      }

      const priceMatch =
        url.match(/price[^\d]*(\d+)/i) || url.match(/\$(\d+)/i) || url.match(/msrp[^\d]*(\d+)/i);
      let salePrice = '';
      if (priceMatch) {
        salePrice = priceMatch[1];
        return { year: '', make: '', model: '', salePrice };
      }

      return null;
    } catch (error) {
      console.error('Error parsing URL:', error);
      return null;
    }
  };

  const handleAutoFill = () => {
    if (!urlInput.trim()) {
      setUrlStatus({ message: 'Please enter a vehicle URL', type: 'error' });
      return;
    }
    const parsed = parseVehicleURL(urlInput);
    if (parsed) {
      let targetIndex = vehicles.findIndex((v) => !v.year && !v.make && !v.model);
      if (targetIndex === -1) {
        addVehicle();
        targetIndex = vehicles.length;
      }
      const newVehicles = [...vehicles];
      if (newVehicles[targetIndex]) {
        newVehicles[targetIndex] = {
          ...newVehicles[targetIndex],
          year: parsed.year || newVehicles[targetIndex].year,
          make: parsed.make || newVehicles[targetIndex].make,
          model: parsed.model || newVehicles[targetIndex].model,
          salePrice: parsed.salePrice || newVehicles[targetIndex].salePrice
        };
      } else {
        newVehicles.push({
          year: parsed.year || '',
          make: parsed.make || '',
          model: parsed.model || '',
          salePrice: parsed.salePrice || '',
          apr: 5.9,
          months: 84,
          down: 20,
          stockNumber: '',
          customMake: '',
          financeType: 'finance',
          leaseMonths: 48,
          totalDueAtSigning: ''
        });
      }
      setVehicles(newVehicles);

      const filled = [];
      if (parsed.year) filled.push('Year');
      if (parsed.make) filled.push('Make');
      if (parsed.model) filled.push('Model');
      if (parsed.salePrice) filled.push('Price');

      setUrlStatus({ message: `Successfully filled: ${filled.join(', ')}`, type: 'success' });
      setUrlInput('');
    } else {
      setUrlStatus({
        message: 'Could not extract vehicle info from this URL. Try a different dealership URL.',
        type: 'error'
      });
    }
    setTimeout(() => setUrlStatus({ message: '', type: '' }), 3000);
  };

  const carMakes = [
    'Acura', 'Audi', 'BMW', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler',
    'Dodge', 'Fiat', 'Ford', 'GMC', 'Honda', 'Hyundai', 'Infiniti', 'Jeep',
    'Kia', 'Lexus', 'Mazda', 'Mercedes-Benz', 'Mitsubishi', 'Nissan', 'RAM',
    'Subaru', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo'
  ];

  return (
    <Section title="Vehicles" defaultOpen={false}>
      <div className="vehicles-container">
        {/* URL Auto-Fill Section */}
        {isEditing && (
          <div className="vehicles-url-section">
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px' }}>
              <input
                className="vehicles-url-input"
                placeholder="Paste dealership URL (e.g., https://dealership.com/used/Ford/2022-Ford-Bronco...)"
                value={urlInput}
                onChange={(e) => setUrlInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAutoFill()}
              />
              <button
                onClick={handleAutoFill}
                className="vehicles-url-button"
                disabled={!urlInput.trim()}
              >
                Auto-Fill
              </button>
            </div>
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
              Note: Auto-fill extracts Year, Make, and Model from URLs. Price must be entered manually.
            </div>
            {urlStatus.message && (
              <div className={`vehicles-url-status ${urlStatus.type}`}>
                {urlStatus.message}
              </div>
            )}
          </div>
        )}

        {/* Vehicles Table */}
        <div className="vehicles-table-container">
          <table className="vehicles-table">
            <thead className="vehicles-table-header">
              <tr>
                <th className="vehicles-col-number">#</th>
                <th className="vehicles-col-finance-type">Type</th>
                <th className="vehicles-col-year">Year</th>
                <th className="vehicles-col-make">Make</th>
                <th className="vehicles-col-model">Model</th>
                <th className="vehicles-col-price">Per Mo / Sale Price</th>
                <th className="vehicles-col-apr">APR / Term</th>
                <th className="vehicles-col-months">Months / Due</th>
                <th className="vehicles-col-down">Down %</th>
                <th className="vehicles-col-stock">Stock #</th>
                <th className="vehicles-col-payment">Payment</th>
                <th className="vehicles-col-delete">Action</th>
              </tr>
            </thead>

            <tbody className="vehicles-table-body">
              {vehicles.map((vehicle, idx) => {
                // Calculate payment based on finance type
                let displayPayment;
                if (vehicle.financeType === 'lease') {
                  displayPayment = vehicle.salePrice ? `$${vehicle.salePrice}/mo` : '$0/mo';
                } else {
                  const monthly = calculateMonthlyPayment(
                    parseFloat(vehicle.salePrice || 0),
                    parseFloat(vehicle.down || 20),
                    parseFloat(vehicle.apr || 5.9),
                    parseInt(vehicle.months || 84, 10)
                  );
                  displayPayment = `$${monthly}/mo`;
                }


                // Compliance sub-row (medium + ftc-enhanced tier orders)
                const showCompliance =
                  (complianceTier === 'ftc-enhanced' || complianceTier === 'medium') &&
                  (vehicle.make || vehicle.model);
                const isLease = vehicle.financeType === 'lease';
                const enhancedTier = complianceTier === 'ftc-enhanced';

                return (
                  <React.Fragment key={idx}>
                  <tr className="vehicles-table-row">
  {/* Vehicle Number + up/down buttons */}
  <td
    className="vehicles-table-cell vehicles-number-cell"
    title={isEditing ? 'Use arrows to reorder' : ''}
  >
    <div className="vehicles-number-badge">{idx + 1}</div>

    {isEditing && (
      <div className="vehicles-move-buttons">
        <button
          type="button"
          className="vehicles-move-btn"
          onClick={() => moveUp(idx)}
          disabled={idx === 0}
          aria-label={`Move vehicle ${idx + 1} up`}
          title="Move up"
        >
          ▲
        </button>
        <button
          type="button"
          className="vehicles-move-btn"
          onClick={() => moveDown(idx)}
          disabled={idx === vehicles.length - 1}
          aria-label={`Move vehicle ${idx + 1} down`}
          title="Move down"
        >
          ▼
        </button>
      </div>
    )}
  </td>




                    {/* Finance Type */}
                    <td className="vehicles-table-cell">
                      <select
                        className="vehicles-select"
                        disabled={!isEditing}
                        value={vehicle.financeType || 'finance'}
                        onChange={(e) => handleChange(idx, 'financeType', e.target.value)}
                      >
                        <option value="finance">Finance</option>
                        <option value="lease">Lease</option>
                      </select>
                    </td>

                    {/* Year */}
                    <td className="vehicles-table-cell">
                      <select
                        className="vehicles-select"
                        disabled={!isEditing}
                        value={vehicle.year}
                        onChange={(e) => handleChange(idx, 'year', e.target.value)}
                      >
                        <option value="">Year</option>
                        {[...Array(27)].map((_, i) => {
                          const year = 2027 - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </td>

                    {/* Make */}
                    <td className="vehicles-table-cell">
                      <div className="vehicles-make-field">
                        <select
                          className="vehicles-select"
                          disabled={!isEditing}
                          value={vehicle.make}
                          onChange={(e) => handleMakeChange(idx, e.target.value)}
                        >
                          <option value="">Make</option>
                          {carMakes.map((make) => (
                            <option key={make} value={make}>
                              {make}
                            </option>
                          ))}
                          <option value="Other">Other</option>
                        </select>

                        {vehicle.make === 'Other' && (
                          <input
                            className="vehicles-custom-make-input"
                            placeholder="Enter make"
                            disabled={!isEditing}
                            value={vehicle.customMake || ''}
                            onChange={(e) => handleCustomMakeChange(idx, e.target.value)}
                          />
                        )}
                      </div>
                    </td>

                    {/* Model */}
                    <td className="vehicles-table-cell">
                      <input
                        className="vehicles-input"
                        placeholder="Model"
                        disabled={!isEditing}
                        value={vehicle.model}
                        onChange={(e) => handleChange(idx, 'model', e.target.value)}
                      />
                    </td>

                    {/* Price or Lease Payment input */}
                    <td className="vehicles-table-cell">
                      <input
                        className="vehicles-input"
                        placeholder={vehicle.financeType === 'lease' ? 'Monthly Payment' : 'Sale Price'}
                        disabled={!isEditing}
                        type="number"
                        value={vehicle.salePrice}
                        onChange={(e) => handleChange(idx, 'salePrice', e.target.value)}
                        title={vehicle.financeType === 'lease' ? 'Monthly lease payment' : 'Sale price'}
                      />
                    </td>

                    {/* APR / Lease Term */}
                    <td className="vehicles-table-cell">
                      {vehicle.financeType === 'lease' ? (
                        <select
                          className="vehicles-select"
                          disabled={!isEditing}
                          value={vehicle.leaseMonths || 48}
                          onChange={(e) => handleChange(idx, 'leaseMonths', e.target.value)}
                          title="Lease term in months"
                        >
                          <option value={24}>24 mo</option>
                          <option value={36}>36 mo</option>
                          <option value={39}>39 mo</option>
                          <option value={42}>42 mo</option>
                          <option value={48}>48 mo</option>
                        </select>
                      ) : (
                        <input
                          className="vehicles-input"
                          placeholder="5.9"
                          disabled={!isEditing}
                          type="number"
                          step="0.1"
                          value={vehicle.apr}
                          onChange={(e) => handleChange(idx, 'apr', e.target.value)}
                          title="Annual Percentage Rate"
                        />
                      )}
                    </td>

                    {/* Months / Due at signing */}
                    <td className="vehicles-table-cell">
                      {vehicle.financeType === 'lease' ? (
                        <input
                          className="vehicles-input"
                          placeholder="3731"
                          disabled={!isEditing}
                          type="number"
                          value={vehicle.totalDueAtSigning}
                          onChange={(e) => handleChange(idx, 'totalDueAtSigning', e.target.value)}
                          title="Total due at lease signing"
                        />
                      ) : (
                        <input
                          className="vehicles-input"
                          placeholder="84"
                          disabled={!isEditing}
                          type="number"
                          value={vehicle.months}
                          onChange={(e) => handleChange(idx, 'months', e.target.value)}
                          title="Finance term in months"
                        />
                      )}
                    </td>

                    {/* Down % (finance only) */}
                    <td className="vehicles-table-cell">
                      {vehicle.financeType === 'lease' ? (
                        <span className="vehicles-na-text">N/A</span>
                      ) : (
                        <input
                          className="vehicles-input"
                          placeholder="20"
                          disabled={!isEditing}
                          type="number"
                          value={vehicle.down}
                          onChange={(e) => handleChange(idx, 'down', e.target.value)}
                          title="Down payment percentage"
                        />
                      )}
                    </td>

                    {/* Stock # */}
                    <td className="vehicles-table-cell">
                      <input
                        className="vehicles-input"
                        placeholder="ABC123"
                        disabled={!isEditing}
                        value={vehicle.stockNumber}
                        onChange={(e) => handleChange(idx, 'stockNumber', e.target.value)}
                      />
                    </td>

                    {/* Calculated Payment */}
                    <td className="vehicles-table-cell vehicles-payment-cell">
                      {displayPayment}
                      {vehicle.financeType === 'lease' && vehicle.leaseMonths && (
                        <div style={{ fontSize: '10px', color: '#666' }}>{vehicle.leaseMonths} mo lease</div>
                      )}
                    </td>

                    {/* Delete */}
                    <td className="vehicles-table-cell">
                      <button
                        disabled={!isEditing || vehicles.length <= 1}
                        onClick={() => removeVehicle(idx)}
                        className="vehicles-delete-button"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>

                  {/* Compliance details sub-row */}
                  {showCompliance && (
                    <tr className="vehicles-compliance-row">
                      <td colSpan={12} className="vehicles-compliance-cell">
                        <div className="vehicles-compliance-fields">
                          <span className={`vehicles-compliance-tag ${enhancedTier ? 'enhanced' : 'medium'}`}>
                            {enhancedTier ? '🛡️ FTC' : '⚠️ MED'}
                          </span>
                          <label className="vehicles-compliance-field">
                            <span>Trim</span>
                            <input
                              className="vehicles-input"
                              placeholder="e.g. 2.5 S"
                              disabled={!isEditing}
                              value={vehicle.trim || ''}
                              onChange={(e) => handleChange(idx, 'trim', e.target.value)}
                            />
                          </label>
                          <label className="vehicles-compliance-field">
                            <span>VIN {isLease && enhancedTier ? '(preferred)' : '(optional)'}</span>
                            <input
                              className="vehicles-input"
                              placeholder="Full VIN"
                              disabled={!isEditing}
                              value={vehicle.vin || ''}
                              onChange={(e) => handleChange(idx, 'vin', e.target.value)}
                            />
                          </label>
                          {isLease && (
                            <label className="vehicles-compliance-field">
                              <span>MSRP ($)</span>
                              <input
                                className="vehicles-input"
                                placeholder="29900"
                                type="number"
                                disabled={!isEditing}
                                value={vehicle.msrp || ''}
                                onChange={(e) => handleChange(idx, 'msrp', e.target.value)}
                                title="Enables the automatic lease payment sanity check"
                              />
                            </label>
                          )}
                          {isLease && enhancedTier && (
                            <>
                              <label className="vehicles-compliance-field">
                                <span>Destination ($)</span>
                                <input
                                  className="vehicles-input"
                                  placeholder="1495"
                                  type="number"
                                  disabled={!isEditing}
                                  value={vehicle.destinationCharge || ''}
                                  onChange={(e) => handleChange(idx, 'destinationCharge', e.target.value)}
                                />
                              </label>
                              <label className="vehicles-compliance-field">
                                <span>Cap Cost ($)</span>
                                <input
                                  className="vehicles-input"
                                  placeholder="26456"
                                  type="number"
                                  disabled={!isEditing}
                                  value={vehicle.capitalizedCost || ''}
                                  onChange={(e) => handleChange(idx, 'capitalizedCost', e.target.value)}
                                />
                              </label>
                              <label className="vehicles-compliance-field">
                                <span>Acq. Fee ($)</span>
                                <input
                                  className="vehicles-input"
                                  placeholder="750 (0 if none)"
                                  type="number"
                                  disabled={!isEditing}
                                  value={vehicle.acquisitionFee ?? ''}
                                  onChange={(e) => handleChange(idx, 'acquisitionFee', e.target.value)}
                                />
                              </label>
                              <label className="vehicles-compliance-field">
                                <span>Miles / Year</span>
                                <input
                                  className="vehicles-input"
                                  placeholder="10000"
                                  type="number"
                                  disabled={!isEditing}
                                  value={vehicle.milesPerYear || ''}
                                  onChange={(e) => handleChange(idx, 'milesPerYear', e.target.value)}
                                />
                              </label>
                              <label className="vehicles-compliance-field">
                                <span>Overage $ / Mile</span>
                                <input
                                  className="vehicles-input"
                                  placeholder="0.15"
                                  type="number"
                                  step="0.01"
                                  disabled={!isEditing}
                                  value={vehicle.overagePerMile || ''}
                                  onChange={(e) => handleChange(idx, 'overagePerMile', e.target.value)}
                                />
                              </label>
                              <label className="vehicles-compliance-field">
                                <span>Disposition ($)</span>
                                <input
                                  className="vehicles-input"
                                  placeholder="350"
                                  type="number"
                                  disabled={!isEditing}
                                  value={vehicle.dispositionFee || ''}
                                  onChange={(e) => handleChange(idx, 'dispositionFee', e.target.value)}
                                />
                              </label>
                              <label className="vehicles-compliance-field">
                                <span>Purch. Option ($, opt.)</span>
                                <input
                                  className="vehicles-input"
                                  placeholder="25315"
                                  type="number"
                                  disabled={!isEditing}
                                  value={vehicle.purchaseOption || ''}
                                  onChange={(e) => handleChange(idx, 'purchaseOption', e.target.value)}
                                />
                              </label>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Add Vehicle + Import Vehicles */}
        <div className="vehicles-add-section" style={{ gap: '12px' }}>
          <button
            type="button"
            disabled={!isEditing}
            onClick={addVehicle}
            className="vehicles-add-button-centered"
          >
            ADD VEHICLE
          </button>
          {onImportRequest && (
            <button
              type="button"
              onClick={() => onImportRequest('vehicles')}
              style={{
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '14px',
                letterSpacing: '0.5px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)',
                minWidth: '140px',
              }}
            >
              ↓ IMPORT VEHICLES
            </button>
          )}
        </div>
      </div>
    </Section>
  );
}